import $ from 'jquery';

$(() => {
    const $menuLinks = $('.js-menu-detail-btn a');

    if ($menuLinks.length === 0) {
        return;
    }

    const $menuDetails = $('.menu-detail');
    const showMenu = menuCode => {
        const $menuLinkItem = $menuLinks.filter(`[data-menu=${menuCode}]`);
        const $menuDetailItem = $menuDetails.filter(`#menu-${menuCode}`);

        $menuDetails.removeClass('active');
        $menuDetailItem.addClass('active');

        $menuLinks.removeClass('active');
        $menuLinkItem.addClass('active');
    };

    window.addEventListener('popstate', event => {
        if (event.state !== null && 'menuCode' in event.state) {
            showMenu(event.state.menuCode);
        }
    });

    $menuLinks.click(evt => {
        evt.preventDefault();
        evt.stopPropagation();

        const $link = $(evt.target);
        const menuCode = $link.data('menu');
        const menuUrl = $link.attr('href');

        showMenu(menuCode);

        window.history.pushState({ menuCode }, document.title, menuUrl);
    });
});
